module.exports = __webpack_public_path__ + "assets/img/icon-mynavi.571d7f3e.svg";